<template>
  <div class="money-back" v-if="offers.length">
    <div class="banner-offer banner-desktop" v-if="phone.banners.desktop"><img :src="phone.banners.desktop.url" :alt="phone.banners.desktop.alt"></div>
    <div class="banner-offer banner-mobile" v-if="phone.banners.mobile"><img :src="phone.banners.mobile.url" :alt="phone.banners.mobile.alt"></div>
    <div class="banner-content" v-if="phone.banners.content"><p>{{ phone.banners.content }}</p></div>
    <div class="attr-label" v-if="offers.length === 1"><p>{{ labelSingular }}</p></div>
    <div class="attr-label" v-if="offers.length > 1"><p>{{ labelPlural }}</p></div>
    <div class="attr-content">
      <div class="offer" v-for="(offer, index) in offers" :key="index">
        <p><span>{{ offer.nomPublic }}</span> {{ offer.details }}</p>
      </div>
      <div class="offer" v-if="!offers.length">
        <p>Aucune offre n'est actuellement disponible pour votre sélection.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MoneyBack',
  props: {
    labelSingular: String,
    labelPlural: String
  },
  computed: {
    ...mapState({
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    }),
    offers () {
      const offers = []

      this.phone.offers.forEach((offer) => {
        if(offer.typePromotion.nom === 'ODR' || offer.typePromotion.nom === 'Flash' || offer.typePromotion.nom === 'ODR Assu' || offer.typePromotion.nom === 'Flash Assu') {
          offers.push(offer)
        }
      })

      return offers
    }
  },
  methods: {
    padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    },
    formatDate(date) {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/')
    },
    formatPrice (amount) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.money-back{
  margin-bottom: 20px;

  .banner-offer{
    margin-bottom: 10px;

    @include responsive(mobile){
      display: none;
    }

    &.banner-mobile{
      display: none;

      @include responsive(mobile){
        display: block;
      }
    }

    img{
      width: 100%;
      height: auto;
    }
  }

  .banner-content{
    margin-bottom: 10px;

    p{
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontRegular;
      color: rgba($black, 0.8);
    }
  }

  .attr-label {
    margin-bottom: 15px;

    p {
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontSemiBold;
    }
  }

  .attr-content{
    margin-bottom: 10px;

    p{
      font-size: px2rem(14px);
      line-height: px2rem(19px);
      font-weight: $fontRegular;
      margin-bottom: 5px;

      &.date{
        font-size: px2rem(12px);
        line-height: px2rem(17px);
        font-weight: $fontRegular;
      }

      strong{
        font-weight: $fontSemiBold;
        color: $primary;
      }
    }
  }

  .attr-content{
    .offer{
      padding: 15px;
      background-color: darken($white, 2%);
      margin-bottom: 15px;
      @include radius(10px);

      &:last-child{
        margin-bottom: 0;
      }

      span{
        display: inline-block;
        background-color: $yellow;
        color: $black;
        font-weight: $fontSemiBold;
        font-size: px2rem(12px);
        padding: 0 10px;
        height: 20px;
        margin-right: 3px;
        line-height: 20px;
        vertical-align: middle;
        @include box-sizing();
        @include radius(5px);
        @include transform(translateY(-2px));

        @include responsive(mobile){
          display: block;
          width: 100%;
          height: auto;
          padding: 5px 10px;
          margin-bottom: 5px;
        }
      }

      p{
        line-height: px2rem(20px);
      }
    }
  }
}
</style>
